import { Root } from "react-dom/client";
import Animation from "../system/Animation";

export interface StyledUI {
  width?: number;
  height?: number;
  selected?: boolean;
  size?: number;
  weight?: number;
  texture?: string;
}

export enum PlayWith {
  Bot,
  Players,
}

export class UIScene extends Phaser.Scene {
  sfx_bgm: Phaser.Sound.BaseSound;
  sfx_levelup: Phaser.Sound.BaseSound;
  sfx_cointoss: Phaser.Sound.BaseSound;
  sfx_leveldown: Phaser.Sound.BaseSound;
  sfx_jump: Phaser.Sound.BaseSound;
  sfx_nice: Phaser.Sound.BaseSound;

  mode?: PlayWith;

  currentSelection: number;

  ready?: boolean;
  onReady?: Function;
  vfxScene?: VFXScene;

  tags?: string[];
  battleAnimation: Animation;

  GameStartPhase?(): void;
  BuyCharacterPhase?(): void;
  BattlePhase?(): void;
}

export class VFXScene extends Phaser.Scene {
  onReady?: Function;
  gameScene?: Phaser.Scene;
  spellLine?: Phaser.GameObjects.Line;
}

export interface UIZone extends Phaser.GameObjects.Zone {
  slotIndex?: number;
}

export interface UIContainer extends Phaser.GameObjects.Container {
  tag?: string;
  root?: Root;
  domElement?: Phaser.GameObjects.DOMElement;
  dimension?: object;

  hasTreasureCard?: boolean;
  index?: number;
  lastPosition?: Phaser.Math.Vector2;
  zone?: UIZone;

  //Event
  isDown?: boolean;
}
